<template>
  <div>
    <div class="ball-toggle">
      <div class="ball-toggle__title">
        {{ title }}
      </div>
      <button
        @click="$emit('toggle')"
        class="ball-toggle__toggle-icon focusable"
      >
        <img src="@/assets/images/ticket/minimise-dark.png" />
      </button>
    </div>
    <component
        v-if="isShow"
        :is="data"
        :listData="dataComponent"
        :numbers="numbers"
        @clickItem="handleClickItemMoreMarket"
        @handleChosenItem="handleChosenNumber"
        @handleAddLine="$emit('handleAddLine')"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      default: null
    },
    isShow: {
      type: Boolean,
      default: true
    },
    dataComponent: {
      type: Object
    },
    numbers: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    handleClickItemMoreMarket(value) {
      this.$emit('clickItem', value)
    },
    handleChosenNumber(index) {
      this.$emit('handleChosenItem', index)
    }
  }
}
</script>

<style scoped lang="scss" src="@/assets/scss/common/ball/ball-toggle.scss"/>
